export default "__VITE_ASSET__f133f6a8__"